import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { downloadService } from '../services/download/download.service';
import type {
    S3LinksRequest,
    DownloadFileLink,
} from '../services/download/download.types';

export const useFetchS3LinksMutation = (
    options?: UseMutationOptions<
        DownloadFileLink[],
        Error,
        S3LinksRequest
    >
) => {
    return useMutation<
        DownloadFileLink[],
        Error,
        S3LinksRequest
    >({
        mutationFn: downloadService.fetchS3Links,
        ...options,
    })
}

export const useDownloadS3FileMutation = (
    options?: UseMutationOptions<
        void,
        Error,
        { signedToken: string; fileName: string }
    >
) => {
    return useMutation<
        void,
        Error,
        { signedToken: string; fileName: string }
    >({
        mutationFn: ({ signedToken, fileName }) =>
            downloadService.downloadS3File(signedToken, fileName),
        ...options,
    })
}

export const useDownloadDQReportMutation = (
    options?: UseMutationOptions<void, Error, string>
) => {
    return useMutation<void, Error, string>({
        mutationFn: downloadService.downloadDQReport,
        ...options,
    })
}

export const useDownloadDestinationFileMutation = (
    options?: UseMutationOptions<
        void,
        Error,
        { folderName: string; targetTableId: number }
    >
) => {
    return useMutation<
        void,
        Error,
        { folderName: string; targetTableId: number }
    >({
        mutationFn: ({ folderName, targetTableId }) =>
            downloadService.downloadDestinationFile(folderName, targetTableId),
        ...options,
    })
}
